import React from 'react';
import { CheckCircle2 } from 'lucide-react';

const About = () => {
  const highlights = [
    'Turnkey Interior Solutions',
    'Commercial Office Design',
    'Luxury Showroom Interiors',
    'Residential Interiors',
    'Project Management',
    'Custom Furniture Design',
    'Space Planning',
    'Quality Execution'
  ];

  return (
    <section id="about" className="py-24 px-6 bg-[#0a0a0c]">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-20">
          <p className="text-[#FF8C42] text-sm tracking-[0.3em] uppercase mb-4">About Us</p>
          <h2
            className="text-4xl md:text-5xl font-serif text-white mb-6"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            Classic Decor Story
          </h2>
        </div>

        {/* Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Column - Company Info */}
          <div>
            <h3 className="text-2xl font-serif text-white mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
              Crafting Excellence Since 2004
            </h3>
            <p className="text-white/70 text-lg leading-relaxed mb-6">
              Classic Decor is a premier interior design company based in Bangalore, dedicated to transforming spaces into timeless masterpieces. With 21 years of experience, we specialize in creating exceptional interiors that blend functionality with aesthetic brilliance.
            </p>
            <p className="text-white/70 text-lg leading-relaxed mb-8">
              Our team of skilled designers and craftsmen work closely with clients to understand their vision and deliver tailored solutions that exceed expectations. From corporate offices to luxury showrooms, every project reflects our commitment to quality, innovation, and attention to detail.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-8 py-8 border-t border-b border-white/10">
              <div>
                <p className="text-4xl font-serif text-[#FF8C42] mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
                  21
                </p>
                <p className="text-white/60 text-sm">Years Experience</p>
              </div>
              <div>
                <p className="text-4xl font-serif text-[#FF8C42] mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
                  100+
                </p>
                <p className="text-white/60 text-sm">Projects Completed</p>
              </div>
              <div>
                <p className="text-4xl font-serif text-[#FF8C42] mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
                  80+
                </p>
                <p className="text-white/60 text-sm">Happy Clients</p>
              </div>
            </div>
          </div>

          {/* Right Column - Services List */}
          <div className="bg-[#1a1a1c] p-10 rounded-sm">
            <h3 className="text-2xl font-serif text-white mb-8" style={{ fontFamily: 'Playfair Display, serif' }}>
              Our Expertise
            </h3>
            <div className="grid grid-cols-1 gap-4">
              {highlights.map((item, index) => (
                <div key={index} className="flex items-center gap-4 group">
                  <CheckCircle2 size={20} className="text-[#FF8C42] flex-shrink-0 group-hover:scale-110 transition-transform" />
                  <span className="text-white/80 group-hover:text-white transition-colors">{item}</span>
                </div>
              ))}
            </div>

            {/* Mission Statement */}
            <div className="mt-10 pt-10 border-t border-white/10">
              <h4 className="text-lg font-serif text-[#FF8C42] mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
                Our Mission
              </h4>
              <p className="text-white/70 leading-relaxed">
                To create inspiring spaces that enhance the quality of life and work, combining innovative design with impeccable craftsmanship and delivering excellence in every project.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;